import { supabase } from '@/lib/supabase';

export type AccessResource = {
  key: string;
  label: string;
  kind: 'tab' | 'feature' | 'table';
  path: string | null;
  default_allowed: boolean;
  admin_only: boolean;
};
export type EffectiveAccess = { resources: AccessResource[]; allowed: Record<string, boolean>; is_admin?: boolean };
export type AccessSubject = { type: 'role' | 'user'; id: string };
export type AccessConfiguration = EffectiveAccess & {
  revision: number;
  overrides: Record<string, boolean>;
  inherited: Record<string, boolean>;
  protected: boolean;
};

export async function getMyAppAccess(): Promise<EffectiveAccess> {
  const { data, error } = await supabase.rpc('get_my_app_access');
  if (error) throw error;
  if (!data?.resources || !data?.allowed) throw new Error('Invalid access response');
  return data;
}

export async function getAccessConfiguration(subject: AccessSubject): Promise<AccessConfiguration> {
  const { data, error } = await supabase.rpc('get_app_access_configuration', {
    p_subject_type: subject.type, p_subject_id: subject.id,
  });
  if (error) throw error;
  return data;
}

export async function saveAccessConfiguration(subject: AccessSubject, revision: number, overrides: Record<string, boolean>) {
  const { error } = await supabase.rpc('save_app_access_configuration', {
    p_subject_type: subject.type, p_subject_id: subject.id,
    p_revision: revision, p_overrides: overrides,
  });
  if (error) throw error;
  window.dispatchEvent(new Event('app-access-changed'));
}
